import { createFileRoute } from '@tanstack/react-router';
import { SigningView } from '@features/signing/SigningView';

export const Route = createFileRoute('/sign/$token')({
  component: SigningPage,
});

function SigningPage() {
  const { token } = Route.useParams();
  return <SigningView token={token} />;
}
